import { render, staticRenderFns } from "./dimensions.vue?vue&type=template&id=3602847a&"
import script from "./dimensions.vue?vue&type=script&lang=js&"
export * from "./dimensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports